<div class="cover-container">
 
  <main>
    <div class="center">
      <h1 class="big-icon"><mat-icon aria-hidden="false" aria-label="coming soon icon" fontIcon="hourglass_top"></mat-icon></h1>
      <h1>Coming Soon</h1>
      <h3>We are still working on it.</h3>      
    </div>
  </main>

</div>

